export var APIStatus;
(function (APIStatus) {
    APIStatus[APIStatus["IDLE"] = 0] = "IDLE";
    APIStatus[APIStatus["PENDING"] = 1] = "PENDING";
    APIStatus[APIStatus["SUCCESS"] = 2] = "SUCCESS";
    APIStatus[APIStatus["FAILED"] = 3] = "FAILED";
})(APIStatus || (APIStatus = {}));
